'use client';

import { useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../store/theme';

export const ThemeToggle = () => {
  const theme = useThemeStore((s) => s.theme);
  const hydrated = useThemeStore((s) => s.hydrated);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);

  useEffect(() => {
    // ✅ гарантированно один раз
    useThemeStore.getState().init();
  }, []);

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Переключить тему"
      className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-200 to-blue-500 cursor-pointer"
    >
      {hydrated ? (
        theme === 'dark' ? <Sun className="text-yellow-400" size={20} /> : <Moon className="text-indigo-900" size={20} />
      ) : (
        <Moon className="text-indigo-900" size={20} />
      )}
    </button>
  );
};
